import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    container: {
        minWidth: '400px',
        backgroundColor: '#f0f0f0',
        border: '1px solid #ccc',
    },
    filterContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '12px'
    },
    filterTitle: {
        marginRight: '12px',
        fontSize: '14',
        fontWeight: 'bold'
    },
    textField: {
        '& .MuiOutlinedInput-input': {
            padding: '8px',
        }
    },
    title: {
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '18'
    },
    card: {
        padding: '12px',
        margin: '8px 0',
        position: 'relative'
    },
    iconBtn: {
        position: 'absolute',
        right: 0,
        top: 0
    }
}))